module.exports = __webpack_public_path__ + "be2615bfd80391bc77e57b666eeb6999.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/123-2.png
// module id = 579
// module chunks = 0